import {
    AUTH_HOST,
    SUMFS_HOST,
    getEnvName
} from '@/config'
import request from '@/service/apiConfig/request'
const originSumfsHost = SUMFS_HOST[getEnvName()]

/** 
 * 首页分类

 */
export const category = (params) => {
    return request.jsonp(originSumfsHost + '/sumis-web/union/sums/promotion/homepage/category.do', params)
}